import { z } from "zod";
import { adminBillingViewSchema, billingConfirmInputSchema, isoUtcSchema, paidSubscriptionSnapshotSchema, tariffIdentitySchema } from "./tariffs.js";
const version = z.number().int().min(0).max(2_147_483_647);
export const billingTariffChangeInputSchema = z.object({
    tariffId: z.string().min(1),
    expectedCatalogVersion: version,
    expectedBillingVersion: version,
}).strict();
export const billingTariffChangeSummarySchema = z.object({
    accountId: z.string().uuid(),
    billingVersion: version,
    catalogVersion: version,
    subscriptionId: z.string().uuid(),
    periodId: z.string().uuid(),
    from: tariffIdentitySchema,
    to: tariffIdentitySchema,
    monthlyDialogs: z.number().int().positive(),
    paidThroughAt: isoUtcSchema.nullable(),
    futureSubscriptions: z.number().int().min(0),
    invoicesToReview: z.number().int().min(0),
    resetsPeriod: z.boolean(),
    calculatedAt: isoUtcSchema,
    expiresAt: isoUtcSchema,
}).strict();
export const billingTariffChangePreviewSchema = billingTariffChangeSummarySchema.extend({ previewToken: z.string().min(1) }).strict();
export const billingTariffChangeConfirmSchema = billingConfirmInputSchema;
export const billingTariffChangeOperationSchema = z.object({
    id: z.string().uuid(), requestId: z.string().min(1), kind: z.literal("CHANGE"),
    effectiveAt: isoUtcSchema, totalRub: z.literal("0"),
    snapshot: paidSubscriptionSnapshotSchema.nullable(),
    tariff: tariffIdentitySchema,
}).strict();
export const billingTariffChangeResultSchema = z.object({
    operation: billingTariffChangeOperationSchema,
    billing: adminBillingViewSchema,
}).strict();
//# sourceMappingURL=billing-tariff-change.js.map